import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import type { PrintCardUpsShopRateQuotesResult } from "../print-card-orders/print-card-orders.interface";
import type {
  CardOrderUpsAccessPoint,
  CardOrderUpsShopRatesQuoteRequest,
} from "./card-orders.interface";

@Injectable({ providedIn: "root" })
export class CardOrdersUpsService {
  constructor(private readonly http: HttpClient) {}

  validateAddress(address: {
    line1: string;
    line2?: string;
    city: string;
    postalCode: string;
    country: string;
  }): { ok: boolean; errorKey?: string } {
    const line1 = address.line1.trim();
    const city = address.city.trim();
    const postalCode = address.postalCode.trim();
    if (!line1 || !city || !postalCode) {
      return {
        ok: false,
        errorKey: "cardOrders.shippingAddressErrors.incomplete",
      };
    }
    return { ok: true };
  }

  searchAccessPoints(params: {
    line1?: string;
    city?: string;
    postalCode?: string;
    country?: string;
  }): Observable<CardOrderUpsAccessPoint[]> {
    const query = new URLSearchParams();
    if (params.line1?.trim()) {
      query.set("line1", params.line1.trim());
    }
    if (params.city?.trim()) {
      query.set("city", params.city.trim());
    }
    if (params.postalCode?.trim()) {
      query.set("postalCode", params.postalCode.trim());
    }
    if (params.country?.trim()) {
      query.set("country", params.country.trim());
    }
    const suffix = query.toString() ? `?${query.toString()}` : "";
    return this.http
      .get<{
        points?: CardOrderUpsAccessPoint[];
      }>(`/ups/access-points${suffix}`)
      .pipe(map((response) => response.points ?? []));
  }

  getShopRates(
    payload: CardOrderUpsShopRatesQuoteRequest,
  ): Observable<PrintCardUpsShopRateQuotesResult> {
    return this.http.post<PrintCardUpsShopRateQuotesResult>(
      "/ups/shop-rates",
      payload,
    );
  }
}
